import React, { useState } from "react";

// Material Dashboard 2 React components
import MDBox from "shared/components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import Footer from "app/layout/Footer";

// Overview page components
import HeaderRol from "modules/rol/components/HeaderRol";
import TablaRol from "./components/TablaRol";

function Rol() {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleRolCreated = () => {
    setRefreshFlag((prev) => !prev); // Cambia el estado para forzar actualización
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={2} />
      <HeaderRol onRolCreated={handleRolCreated}>
        <MDBox mt={2} mb={0}>
          <TablaRol refreshFlag={refreshFlag} />
        </MDBox>
      </HeaderRol>
    </DashboardLayout>
  );
}

export default Rol;
